import { sagasManager } from '@edf-pkg/app-store';

import dashboardSaga, { SAGA_NAME as dashboardSagaName } from './dashboard.saga';

export function inject() {
    sagasManager.add(dashboardSagaName, dashboardSaga);
}
